module.exports = __webpack_public_path__ + "img/setting_29.8830c4e5.svg";